import { createFileRoute } from "@tanstack/react-router";
import ProfesionalesRetail from "@/pages/ProfesionalesRetail";
import { SITE_URL } from "@/lib/site-url";

export const Route = createFileRoute("/profesionales-retail")({
  head: () => {
    const title = "Abogados, licencias, fiscal y reformas para comercios | Retail Lemon";
    const description =
      "Sara IA te orienta; cuando toca firmar o pasar a la acción, te ponemos con profesionales especializados en retail: contratos, licencias, laboral, fiscal y obra del local.";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: `${SITE_URL}/profesionales-retail` },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "es_ES" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
    };
  },
  component: () => <ProfesionalesRetail routeLang="es" />,
});
